import RecyclingPage from '@/views/restricted/recyclingModule/RecyclingPage.vue'
import DistributorLayout from '@/layouts/DistributorLayout.vue'
import RecyclingReportPage from '@/views/restricted/recyclingModule/RecyclingReportPage.vue'
import RecyclingCreateFolderPage from '@/views/restricted/recyclingModule/acquisition/RecyclingCreateFolderPage.vue'
import RecyclingAddAttachmentPage from '@/views/public-access/recyclingModule/RecyclingAddAttachmentPage.vue'

export default [
  {
    path: '/recycling-module/recycling-page',
    name: 'RecyclingPage',
    menuSelected: 'recyclingModule',
    component: RecyclingPage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_RECYCLING_READ']
    }
  },
  {
    path: '/recycling-module/recycling-report-page',
    name: 'RecyclingReportPage',
    menuSelected: 'recyclingModule',
    component: RecyclingReportPage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_RECYCLING_READ']
    }
  },
  {
    path: '/recycling-module/create-folder-page/:recyclingFolderBoomerangId?',
    name: 'RecyclingCreateFolderPage',
    component: RecyclingCreateFolderPage,
    props: true,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_RECYCLING_CREATE']
    }
  },
  {
    path: '/public/recycling-folder/add-attachment',
    name: 'RecyclingAddAttachmentPage',
    component: RecyclingAddAttachmentPage,
    meta: {
      requiresAuth: false
    }
  }
]
